import EnrolmentsSerializer from './base';

export default class Unenrolment extends EnrolmentsSerializer {}
